import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuthStore } from '@/features/auth/store/authStore';
import { postAuthLanding } from '@/features/auth/utils/postAuthLanding';

export function OnboardingRoute({ children }: PropsWithChildren) {
  const user = useAuthStore((s) => s.user);

  if (user?.onboardingCompleted || user?.isSuperAdmin) {
    return <Navigate to={postAuthLanding(user)} replace />;
  }

  return <>{children}</>;
}
